import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import api from '@/api';
export default {
  name: 'MemberCommentList',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isSelect: this.checkauthority('comment_select'),
      isCreate: this.checkauthority('comment_create'),
      isUpdate: this.checkauthority('comment_update'),
      isDelete: this.checkauthority('comment_delete'),
      selectForm: {
        createTime: null,
        fromMemberNo: '',
        toMemberNo: '',
        createTimes: [],
        isDel: '0'
      },
      pageNo: 1,
      pageSize: 10,
      tableSelects: [],
      tableData: [],
      pageTotal: 0,
      title: '',
      type: null,
      objId: null
    };
  },
  methods: {
    handleClose: function handleClose(done) {
      this.$emit('close');
    },
    dalete: function dalete(index, data) {
      var _this = this;
      this.$confirm('此操作将永久隐藏该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.daleteApi(index, data);
      }).catch(function () {
        _this.$message({
          type: 'info',
          message: '已取消隐藏'
        });
      });
    },
    daleteApi: function daleteApi(index, data) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                commentId: data.commentId
              };
              _context.n = 1;
              return api.DELETE_MEMBERCOMMENT(par);
            case 1:
              _this2.initTableData(_this2.type, _this2.objId);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    deleteBatchApi: function deleteBatchApi(par) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return api.DELETE_BATCH_MEMBERCOMMENT(par);
            case 1:
              _this3.$message.success('操作成功');
              _this3.initTableData(_this3.type, _this3.objId);
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    deleteBatch: function deleteBatch() {
      var _this4 = this;
      if (this.tableSelects.length === 0) {
        this.$message.error('请勾选要删除的表格数据');
        return;
      }
      this.$confirm('此操作将永久隐藏该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var par = [];
        _this4.tableSelects.forEach(function (element) {
          par.push(element.commentId);
        });
        _this4.deleteBatchApi(par);
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消隐藏'
        });
      });
    },
    userEditClose: function userEditClose() {
      this.dialogVisible = false;
    },
    setTitle: function setTitle(tile) {
      this.title = tile;
    },
    initTableData: function initTableData(type, objId) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var par, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this5.tableData = [];
              _this5.type = type;
              _this5.objId = objId;
              par = {
                pageNo: _this5.pageNo,
                pageSize: _this5.pageSize,
                isDel: 0,
                businessType: type,
                objId: objId
              };
              _context3.n = 1;
              return api.GET_MEMBERCOMMENT_PAGE_LIST(par);
            case 1:
              res = _context3.v;
              _this5.tableData = res.body.datas;
              _this5.pageTotal = res.body.sumDataCount;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.tableSelects = val;
    }
  }
};